(() => {
  const callback = async () => {
    const fetchSections = async ({ arguments }) => {
      if (!arguments) return;

      try {
        const request = await fetch(`${window.Shopify.routes.root}?sections=${arguments}`, {
          method: 'GET',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        });
        const data = await request.json();

        return data;
      } catch (error) {
        console.error(error);
      }
    };

    const renderSection = ({ section, content }) => {
      if (!section || !content) return;

      section.outerHTML = content;

      document.dispatchEvent(new CustomEvent(`dynamic-section-rendering:${section.dataset.sectionId}:rendered`));
    };

    const unwrapContent = ({ content }) => {
      if (!content) return;

      // Extract the content from the section wrapper
      const element = document.createElement('div');
      element.innerHTML = content;

      return element.firstChild.innerHTML;
    };

    const mapSectionsToArguments = ({ sections }) =>
      Array.from(sections ?? {})
        .map((section) => section.dataset.sectionId)
        .join(',');

    const sectionsToRender = document.querySelectorAll('.dynamic-section-rendering');
    if (!sectionsToRender.length) return;

    const sectionsContent = await fetchSections({ arguments: mapSectionsToArguments({ sections: sectionsToRender }) });

    sectionsToRender.forEach((section) =>
      renderSection({ section, content: unwrapContent({ content: sectionsContent[section.dataset.sectionId] ?? '' }) }),
    );
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
